{
  "AppMenu_AppsTitle": "Menu",
  "AppMenu_Apps_Reporting": "Segnalazione",
  "AppMenu_Apps_FastProvisioning": "Provisioning rapido",
  "AppMenu_Apps_Administration": "Amministrazione",
  "AppMenu_Apps_StatusAndTools": "Stato e strumenti",
  "AppMenu_FavouritesTitle": "Preferiti",
  "NAME": "AppMenu"
}